import {Currency} from "@nolimitcity/slot-game/bin/core/balance/Currency";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Power2, Power3, Power4, TimelineLite, TweenLite} from "gsap";
import {TeslaStrings} from "../../../config/TeslaStrings";
import {TeslaTextStyles} from "../../../config/TeslaTextStyles";
import {TeslaParsedGameData} from "../../server/data/TeslaParsedGameData";
import {Tesla} from "../../Tesla";
import {TeslaGameAssets} from "../../TeslaGameAssets";
import {TeslaGameConfig} from "../../TeslaGameConfig";
import {TeslaSoundConfig} from "../../TeslaSoundConfig";
// import {CountDownTimer} from "../../utils/CountDownTimer";

/**
 * Created by h3 on 2017-10-25.
 */

export class TeslaFreeSpinScreenAnimation extends BaseView {

    private _fsSpiralEffect:TimelineSprite;
    private _fsNumberAnimation:PIXI.BitmapText;
    private _paperAnimation:TimelineSprite;
    private _fsText:PIXI.Sprite;
    private _backgroundGfx:PIXI.Graphics;
    private _fsTextOverlay:PIXI.Sprite;
    private _radialEffect:TimelineSprite;
    private _chargeWildsTextStyle:PIXI.TextStyle;
    private _chargeWilds:PIXI.Text;
    private _youWonTextStyle:PIXI.TextStyle;
    private _youWon:PIXI.Text;
    private _youWonAmount:PIXI.Text;
    private _totalWin:number;
    // private _countDownTimer:CountDownTimer;
    private _countDownContainer:PIXI.Container;
    private _fsPlayed:PIXI.Sprite;
    private _freespinsPlayed:number;
    private _freespinsPlayedText:PIXI.Text;
    private _gameData:TeslaParsedGameData;

    // get timer():CountDownTimer {
    //     return this._countDownTimer;
    // }

    constructor() {
        super(ResourcesGroupName.MAIN);

    }

    protected addEventListeners() {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
    };

    private onGameDataParsed(data:TeslaParsedGameData) {
        this._freespinsPlayed = data.freespinsPlayed;
        this._gameData = data;

    }

    protected initAnimations():void {

        this._backgroundGfx = new PIXI.Graphics();
        this._backgroundGfx.clear();
        this._backgroundGfx.beginFill(0x17172c, 1);
        this._backgroundGfx.drawRect(-1682 * 0.5, -1682 * 0.5, 1682, 1682);
        this._backgroundGfx.endFill();
        this.addChild(this._backgroundGfx);

        this._fsNumberAnimation = new PIXI.BitmapText("0", TeslaTextStyles.FS_NUMBER_TEXT_STYLE);
        this.addChild(this._fsNumberAnimation);

        this._fsSpiralEffect = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.FS_SPIRAL));
        this._fsSpiralEffect.anchor.set(0.467, 0.441);
        this._fsSpiralEffect.scale.set(2, 2);
        this.addChild(this._fsSpiralEffect);

        this._fsText = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.FS_TEXT)[0]);
        this._fsText.anchor.set(0.5, 0.5);
        this._fsText.scale.set(0, 0);
        this.addChild(this._fsText);

        this._fsTextOverlay = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.FS_TEXT_OVERLAY)[0]);
        this._fsTextOverlay.anchor.set(0.5, 0.5);
        this._fsTextOverlay.scale.set(0, 0);
        this._fsTextOverlay.alpha = 0;
        this._fsTextOverlay.blendMode = PIXI.BLEND_MODES.SCREEN;
        this.addChild(this._fsTextOverlay);

        this._radialEffect = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.RADIAL_EFFECT));
        this._radialEffect.alpha = 1;
        this._radialEffect.blendMode = PIXI.BLEND_MODES.ADD;
        this._radialEffect.scale.set(1.5, 0.7);
        this._radialEffect.position.set(0, 40);
        this._radialEffect.hide();
        this._radialEffect.anchor.set(0.5, 0.5);
        this.addChild(this._radialEffect);

        this._paperAnimation = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.FS_PAPER_ANIMATION));
        this._paperAnimation.anchor.set(0.5, 0.5);
        this.addChild(this._paperAnimation);

        this._countDownContainer = new PIXI.Container();
        this.addChild(this._countDownContainer);

        this.createChargeWildText();
        this.createOutroText();
        this.createFsPlayed();
        // this.createTimer();

        this.resetTextAnimation();
        this.resetPaperAndBackground();
        this._fsSpiralEffect.hide();
    }

    // private createTimer() {
    //     this._countDownTimer = new CountDownTimer({
    //         prefixText : Translation.translate(TeslaStrings.TEXT_CLOSE),
    //         secondsText : Translation.translate(TeslaStrings.TEXT_SECONDS),
    //         secondText : Translation.translate(TeslaStrings.TEXT_SECOND),
    //         prefixTextStyle : TeslaTextStyles.FS_TIMER_TEXT,
    //         timeTextStyle : TeslaTextStyles.FS_TIMER_NUMBER,
    //         secondsTextStyle : TeslaTextStyles.FS_TIMER_TEXT,
    //         textSpacing : 5
    //     });
    //     this._countDownTimer.alpha = 0;
    //     this._countDownTimer.x = 0;
    //     this._countDownTimer.y = 0;
    //     this._countDownContainer.addChild(this._countDownTimer);
    // }

    private createChargeWildText() {
        this._chargeWildsTextStyle = new PIXI.TextStyle(TeslaTextStyles.FS_INTRO_CHARGE_WILDS);

        let chargedWildTextPosition:PIXI.Point = new PIXI.Point(0, 0);
        let chargedWildTextAnchor:PIXI.Point = new PIXI.Point(0.5, 0.5);

        this._chargeWilds = new PIXI.Text(Translation.translate(TeslaStrings.FS_INTRO_TEXT), this._chargeWildsTextStyle);
        this._chargeWilds.alpha = 0;
        this._chargeWilds.anchor.set(chargedWildTextAnchor.x, chargedWildTextAnchor.y);
        this._chargeWilds.position.set(chargedWildTextPosition.x, chargedWildTextPosition.y);
        this.addChild(this._chargeWilds);

    }

    private createOutroText() {
        this._youWonTextStyle = new PIXI.TextStyle(TeslaTextStyles.FS_OUTRO);

        let youWonTextAnchor:PIXI.Point = new PIXI.Point(0.5, 0.5);

        this._youWon = new PIXI.Text(Translation.translate(TeslaStrings.FS_YOU_WON_TEXT), this._youWonTextStyle);
        this._youWon.alpha = 0;
        this._youWon.anchor.set(youWonTextAnchor.x, youWonTextAnchor.y);
        this._youWon.position.set(0, -40);


        this._youWonAmount = new PIXI.Text(Currency.formatValue(0), this._youWonTextStyle);
        this._youWonAmount.alpha = 0;
        this._youWonAmount.anchor.set(youWonTextAnchor.x, youWonTextAnchor.y);
        this._youWonAmount.position.set(0, 45);
        this.addChild(this._youWon);
        this.addChild(this._youWonAmount);

        //#203
        if (this._gameData) {
            if (SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (this._gameData.accumulatedRoundWin <= this._gameData.playedBetValue)) {
                this._youWon.visible = false;
            }
        }

    }

    private createFsPlayed() {
        this._fsPlayed = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.TESLA_SPINS_PLAYED)[0]);
        this._fsPlayed.alpha = 0;
        this._fsPlayed.position.set(-200, -200);
        this._fsPlayed.anchor.set(0, 0.5);
        this.addChild(this._fsPlayed);

        this._freespinsPlayedText = new PIXI.Text("", TeslaTextStyles.FS_PLAYED_TEXTSTYLE);
        this._freespinsPlayedText.position.set(0, -200);
        this._freespinsPlayedText.alpha = 0;
        this._freespinsPlayedText.anchor.set(0, 0.5);
        this.addChild(this._freespinsPlayedText);
    }

    private getOutroShow():TimelineLite {

        let fsPlayed = 0;

        if(this._freespinsPlayed) {
            fsPlayed = this._freespinsPlayed;
        }

        this._freespinsPlayedText.text = `${fsPlayed}`;

        const tl:TimelineLite = new TimelineLite();
        if(Currency.getPlayerCurrency().before) {
            this._youWonAmount.text = (`${Currency.getPlayerCurrency().symbol!.trim()} ${Currency.formatValue(this._totalWin)}`);

        } else {
            this._youWonAmount.text = (`${Currency.formatValue(this._totalWin)} ${Currency.getPlayerCurrency().symbol!.trim()}`);
        }

        tl.add([
            new TweenLite(this._youWon, 0.25, {alpha : 1}),
            new TweenLite(this._youWonAmount, 0.25, {alpha : 1}),
            // new TweenLite(this._countDownTimer, 0.25, {alpha : 1}),
            new TweenLite(this._freespinsPlayedText, 0.25, {alpha : 1}),
            new TweenLite(this._fsPlayed, 0.25, {alpha : 1})

        ]);

        return tl;

    }

    private getOutroHide():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add([
            new TweenLite(this._youWon.position, 0.5, {ease : Power4.easeIn, y : 720}),
            new TweenLite(this._youWonAmount.position, 0.5, {ease : Power4.easeIn, y : 720}),
            // new TweenLite(this._countDownTimer.position, 0.5, {ease : Power4.easeIn, y : 720}),
            new TweenLite(this._freespinsPlayedText.position, 0.5, {ease : Power4.easeIn, y : 720}),
            new TweenLite(this._fsPlayed.position, 0.5, {ease : Power4.easeIn, y : 720})
        ]);

        return tl;
    }

    public onResize(resizeData:IResizeData) {
        if(resizeData.orientation == Orientation.PORTRAIT) {
            this.position.set(TeslaGameConfig.instance.GAME_WIDTH * 0.5, TeslaGameConfig.instance.GAME_HEIGHT * 0.45);
            this._countDownContainer.position.set(0, TeslaGameConfig.instance.GAME_HEIGHT * 0.27);
        } else {
            this.position.set(TeslaGameConfig.instance.GAME_WIDTH * 0.5, TeslaGameConfig.instance.GAME_HEIGHT * 0.5);
            this._countDownContainer.position.set(0, TeslaGameConfig.instance.GAME_HEIGHT * 0.32);
        }

        this._fsSpiralEffect.position.set(0, -50);
        this._fsNumberAnimation.position.set(0, -130);
        this._fsText.position.set(0, 50);
        this._fsTextOverlay.position.set(0, 50);
    }

    private updateNumberText(freespinWon:number) {
        this._fsNumberAnimation.text = freespinWon.toString();
        this._fsNumberAnimation.pivot.x = this._fsNumberAnimation.textWidth * 0.5;
        this._fsNumberAnimation.pivot.y = this._fsNumberAnimation.textHeight * 0.5;
    }

    private getShowTextAnimation(freespinWon:number):TimelineLite {
        this.updateNumberText(freespinWon);
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            () => this._fsNumberAnimation.visible = true,
            new TweenLite(this._fsNumberAnimation.scale, 0.15, {x : 1.2, y : 1.2, ease : Power3.easeOut}),
            new TweenLite(this._fsText.scale, 0.15, {x : 1.2, y : 1.2, ease : Power3.easeOut}),
            new TweenLite(this._fsTextOverlay.scale, 0.15, {x : 1.2, y : 1.2, ease : Power3.easeOut}),
            new TweenLite(this._fsTextOverlay, 0.15, {alpha : 1})
        ]);
        tl.add([
            new TweenLite(this._fsNumberAnimation.scale, 0.05, {x : 1, y : 1, ease : Power3.easeIn}),
            new TweenLite(this._fsText.scale, 0.05, {x : 1, y : 1, ease : Power3.easeIn}),
            new TweenLite(this._fsTextOverlay.scale, 0.05, {x : 1, y : 1, ease : Power3.easeIn}),
            new TweenLite(this._fsTextOverlay, 0.4, {alpha : 0, ease : Power2.easeIn})
        ]);

        tl.add([
            this._radialEffect.getAnimationAutoShowHide(true, true, [0, 9]),
        ], "-= 0.4");


        return tl;
    }

    private resetTextAnimation() {
        this._fsNumberAnimation.scale.set(0, 0);
        this._fsNumberAnimation.visible = false;
        this._fsText.scale.set(0, 0);
        this._fsTextOverlay.alpha = 0;
        this._fsTextOverlay.scale.set(0, 0);
    }

    public getShowIntroAnimation(numberOfFreespins:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        const windowAnimation:TimelineLite = Tesla.backgroundWindowAnimation.getAnimation();
        const windowLightningAnimation:TimelineLite = Tesla.backgroundWindowAnimation.getWindowLightning();

        tl.add([
            this._fsSpiralEffect.getAnimationAutoShowHide(true, true),
            () => this.playIntroSound()
        ]);
        tl.add(this.getShowTextAnimation(numberOfFreespins));

        const startFadeTime:number = tl.totalDuration();

        tl.add([
            this._paperAnimation.getAnimationAutoShowHide(true, false),
            () => this.playPaperSound()
        ], "+=2");
        tl.add([
            () => this.resetTextAnimation(),
            new TweenLite(this._chargeWilds, 0.25, {alpha : 1})
            // new TweenLite(this._countDownTimer, 0.25, {alpha : 1})
        ]);


        tl.add([
            windowAnimation,
            windowLightningAnimation
        ], 0);

        tl.add(new TweenLite(this._backgroundGfx, tl.totalDuration() - startFadeTime, {alpha : 0.5}), startFadeTime);

        return tl;
    }

    public getHideIntroAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            new TweenLite(this._paperAnimation.position, 0.5, {ease : Power4.easeIn, y : 720}),
            new TweenLite(this._backgroundGfx, 0.5, {alpha : 0}),
            new TweenLite(this._chargeWilds.position, 0.5, {ease : Power4.easeIn, y : 720}),
            // new TweenLite(this._countDownTimer.position, 0.5, {ease : Power4.easeIn, y : 720})
        ]);
        tl.add(() => this.resetPaperAndBackground());
        return tl;
    }

    private resetPaperAndBackground() {
        this._paperAnimation.hide();
        this._paperAnimation.position.set(0, 0);
        this._chargeWilds.position.set(0, 0);
        this._chargeWilds.alpha = 0;
        // this._countDownTimer.position.set(0, 0);
        // this._countDownTimer.alpha = 0;
        this._backgroundGfx.alpha = 0;
        this._youWon.alpha = 0;
        this._youWon.position.set(0, -40);
        this._youWonAmount.alpha = 0;
        this._youWonAmount.position.set(0, 45);
        this._fsPlayed.position.set(-200, -200);
        this._fsPlayed.alpha = 0;
        this._freespinsPlayedText.position.set(0, -200);
        this._freespinsPlayedText.alpha = 0;

    }

    public getShowOutroAnimation(totalWin:number):TimelineLite {
        this._totalWin = totalWin;
        const tl:TimelineLite = new TimelineLite();
        this.createOutroText();
        tl.add([
            this._paperAnimation.getAnimationAutoShowHide(true, false),
            () => this.playOutroSound(),
            () => this.playPaperSound()
        ], "+=0.5");
        tl.add(this.getOutroShow());
        tl.add(new TweenLite(this._backgroundGfx, tl.totalDuration(), {alpha : 0.5}), 0);
        return tl;
    }

    public getHideOutroAnimation():TimelineLite {


        const tl:TimelineLite = new TimelineLite();
        tl.add([
            new TweenLite(this._paperAnimation.position, 0.5, {ease : Power4.easeIn, y : 720}),
            new TweenLite(this._backgroundGfx, 0.5, {alpha : 0}),
            this.getOutroHide()
        ]);
        tl.add(() => this.resetPaperAndBackground());
        return tl;
    }

    private playPaperSound():void {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => SlotGame.sound.playEffect(TeslaSoundConfig.instance.FS_INTRO_PAPER));

    }

    private playIntroSound():void {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => SlotGame.sound.fadeAmbience(0, 1), "0");
        tl.add(() => SlotGame.sound.playEffect(TeslaSoundConfig.instance.FS_INTRO_NUMBER));

    }

    private playOutroSound():void {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => SlotGame.sound.fadeAmbience(0, 0.1), "0");
        tl.add(() => SlotGame.sound.playEffect(TeslaSoundConfig.instance.FS_ENDS));

    }
}